import { Field } from 'react-final-form';
import { t } from 'ttag';

import { Radio } from '@ui/Radio';
import { Button } from '@ui/Button';

// styles
import s from './PickComplaint.sss';

// types
type ComplaintType = {
  id: number,
  title: string,
};

type PickComplaintProps = {
  className?: string;
  handleSubmit: () => void;
  types: ComplaintType[];
  closeModal: () => void;
  submitting: boolean;
  pristine: boolean;
  step: number;
  isMobile?: boolean
};

export const PickComplaint: React.FC<PickComplaintProps> = ({
  handleSubmit,
  types,
  closeModal,
  submitting,
  pristine,
  step,
  isMobile,
}) => (
  <form onSubmit={handleSubmit}>
    <div>
      {types.map((value) => (
        <label key={value.id} className={s.label}>
          <Field
            name="complaint"
            id={value.id}
            type="radio"
            value={String(value.id)}
            render={({ input }) => <Radio {...input} />}
          />
          {' '}
          {value.title}
        </label>
      ))}
    </div>
    <div className={s.buttonGroup}>
      <Button
        theme="secondary"
        className={isMobile ? s.mobileButton : s.buttonLeft}
        onClick={closeModal}
      >
        {t`Відміна`}
      </Button>
      <Button
        type="submit"
        disabled={submitting || pristine}
        className={isMobile ? s.mobileButton : s.buttonRight}
      >
        {t`Далі ${step} з 3`}
      </Button>
    </div>
  </form>
);

export default PickComplaint;
